module.exports = __webpack_public_path__ + "img/jsfni6.9172dada.png";